import { IKeyObjective } from 'legacy/lut/classes/models/partner360/IFormOptionsJBP'

export const isMdfStrategicInitiative = (
  keyObjective: string | null | undefined,
  keyObjectives: readonly IKeyObjective[]
): boolean => Boolean(keyObjectives.find((item) => item.key === keyObjective)?.mdfSync)

export const isValidKeyInitiativeFundingAmount = (amount: number | null | undefined): boolean =>
  typeof amount === 'number' && Number.isFinite(amount) && amount > 0
